module.exports = __webpack_public_path__ + "img/20200330144010644.40e05fd2.png";